<script lang="ts">
    import { _ } from 'svelte-i18n';
    import IconAdd from '../../shared/Icons/IconAdd.svelte';
    import StatusCircle from './JobStatus/StatusCircle.svelte';
    import ErrorColor from '../../shared/ErrorColor.svelte';
    import IconLowPriority from '../../shared/Icons/IconLowPriority.svelte';
    import IconCalendar from '../../shared/Icons/IconCalendar.svelte';
    import IconTimeWindow from '../../shared/Icons/IconTimeWindow.svelte';
    import Opacity from '../../shared/Opacity.svelte';
    import { debug } from '../../../stores/store';
    import InfoColor from '../../shared/InfoColor.svelte';
    import SuccessColor from '../../shared/SuccessColor.svelte';
    import TimeWindowNotification from '../Planning/TimeWindowNotification.svelte';
    import JobTypeIcon from '../Jobs/JobTypeIcon.svelte';
    import IconError from '../../shared/Icons/IconError.svelte';
    import IconFlashOn from '../../shared/Icons/IconFlashOn.svelte';
    import { JobApi } from './JobApi';
    import { api } from '../../../stores/api';
    import { get } from 'svelte/store';
    import { FriendlyDateGenerator } from '../../utilities/FriendlyDateGenerator';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';

    export let jobType: string | null | undefined = 'delivery';
    export let jobStatus: number;
    export let isNewlyAdded: boolean;
    export let isOptional: boolean | null;
    export let isOverdue: boolean;
    export let timeWindow: any = null;
    export let simpleView: boolean;
    export let adHoc: boolean;
    export let adHocClickable: boolean = true;
    export let jobId: number | null;
    export let jobTargetDate: string = '';
    export let showAdhocIfExists: boolean = true;

    let opacity = 0.2;
    let scaleSimpleView = 0.5;
    let scaleFullView = 0.6;
    let changingAdHoc = false;

    let friendlyTargetDate: FriendlyDateGenerator = new FriendlyDateGenerator(jobTargetDate ?? '');

    function toggleAdhocStatus() {
        // if (!friendlyTargetDate.isToday()) {
        //     console.warn('Cannot toggle ad-hoc status for not today jobs');
        //     return;
        // }
        if (!adHocClickable) {
            console.warn('Ad-hoc status cannot be changed (disabled by variable adHocClickable)');
            return;
        }
        if (jobId === null) {
            console.error('JobId is null (cannot toggle ad-hoc status)');
            return;
        }
        changingAdHoc = true;
        JobApi.setAdhocStatus(get(api), jobId, !adHoc)
            .then(res => {
                adHoc = !adHoc;
                $NotificationSystem.reload();
            })
            .catch(err => {
                console.error('Error toggling ad-hoc status', err);
            })
            .finally(() => {
                changingAdHoc = false;
            });
    }

    $: scale = simpleView ? scaleSimpleView : scaleFullView;

    $: friendlyTargetDate = new FriendlyDateGenerator(jobTargetDate ?? '');
</script>

<div class="status-segment">
    <StatusCircle status={jobStatus} {scale} {jobId} />

    {#if showAdhocIfExists || $debug}
        {#if adHoc}
            <div on:click|stopPropagation={toggleAdhocStatus}>
                <InfoColor>
                    <IconFlashOn {scale} title={$_('Ad-hoc')} spin={changingAdHoc} />
                </InfoColor>
            </div>
        {:else if false}
            <div on:click|stopPropagation={toggleAdhocStatus}>
                <Opacity {opacity}>
                    <IconFlashOn {scale} title={$_('Ad-hoc')} spin={changingAdHoc} />
                </Opacity>
            </div>
        {/if}
    {/if}

    <!-- nie pokazujemy tego, prośba Rafała 2024-06-28 -->
    {#if isOptional !== null && false}
        {#if isOptional}
            <InfoColor>
                <IconLowPriority {scale} title={$_('Optional')} />
            </InfoColor>
        {:else if false}
            <Opacity {opacity}>
                <IconLowPriority {scale} title={$_('Optional')} />
            </Opacity>
        {/if}
    {/if}

    {#if isOverdue || $debug}
        <ErrorColor>
            <IconCalendar {scale} title={$_('Overdue')} />
        </ErrorColor>
    {:else if false}
        <Opacity {opacity}>
            <IconCalendar {scale} title={$_('Overdue')} />
        </Opacity>
    {/if}

    <!--    <TimeWindowNotification {timeWindow} {scale} />-->

</div>

<style>
    .status-segment {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        column-gap: 2px;
    }
</style>
